import { ZERO_TIME } from './constants.js';

export const beautifyTime = (value: string) => {
  switch (value.length) {
    case 0: {
      return '';
    }
    case 1: {
      return `0${value}`;
    }
    case 2: {
      return value;
    }
    default: {
      return ZERO_TIME;
    }
  }
};

export const parseTimeValue = (
  type: 'startTime' | 'endTime',
  value: string | null,
) => {
  if (!value) {
    return {
      hours: '',
      minutes: '',
    };
  }

  const timeParts = value.split(/[:-]/);

  if (type === 'startTime') {
    return {
      hours: timeParts[0],
      minutes: timeParts[1],
    };
  }

  return {
    hours: timeParts[2],
    minutes: timeParts[3],
  };
};
